// TODO @flow WTF is this crap??
import {iframeToSdkChannel} from "../messaging/IframeToSdkChannel";
import {IFrameMessages} from "../messaging/IFrameMessages";
import {Dispatcher} from "../../stem-core/base/Dispatcher";
import {walletModule} from "./WalletModule";
import {INSUFFICIENT_FUNDS_ERROR_CODE} from "../Constants";
import {WidgetRoutes} from "../../blinkpay/widget/WidgetRoutes";
import {NOOP_FUNCTION} from "../../stem-core/base/Utils";
import type {PanelPaymentDetails} from "../PanelOptionsLogic";

// What a merchant passes to requestPayment: the same fields a panel's paymentDetails option takes, with the
// offer named, since payment requests are kept and answered by offer id
export interface PaymentRequest extends PanelPaymentDetails {
    offerId: string | number;
}

interface PaymentError {
    // The backend's APIError.code, an int (payments/errors.py)
    code?: number;
    message?: string;
}

// Whatever the purchase call answered, passed through to the merchant's callbacks untouched
interface PaymentResponse {
    [key: string]: any;
}

interface PaymentCallbacks {
    onSuccess: ((response: PaymentResponse) => void)[];
    onError: ((error: PaymentError) => void)[];
}

interface PaymentRecord {
    request: PaymentRequest;
    error?: PaymentError;
    response?: PaymentResponse;
}

class PurchaseModule {
    paymentRequestReceived = new Dispatcher();
    paymentRequestCompleted = new Dispatcher();

    paymentRequests = new Map<string | number, PaymentRecord>();

    paymentCallbacks = new Map<string | number, PaymentCallbacks>();

    // The queue holds arguments objects, which TypeScript cannot reconcile with the fixed-arity call they
    // are replayed into below: typing the field breaks the cast there, and vice versa
    pendingRequests = [];

    lastPaymentRequestData: PaymentRequest = {} as PaymentRequest;

    init() {
        iframeToSdkChannel.addListener(IFrameMessages.MAKE_PAYMENT_VIA_SDK, ({request}: PaymentRecord) => this.requestPayment(request));

        iframeToSdkChannel.addListener(IFrameMessages.PAYMENT_RESPONSE, ({request, response, error}: PaymentRecord) => {
            const offerCallbacks = this.paymentCallbacks.get(request.offerId) || {onSuccess: [], onError: []};
            if (response) {
                this.paymentRequests.set(request.offerId, {request, response});
                offerCallbacks.onSuccess.forEach(callback => callback(response));
                offerCallbacks.onSuccess = [];
            } else {
                this.paymentRequests.set(request.offerId, {request, error});
                offerCallbacks.onError.forEach(callback => callback(error));
                offerCallbacks.onError = [];
                if (request.offerId === this.lastPaymentRequestData.offerId && error.code === INSUFFICIENT_FUNDS_ERROR_CODE) {
                    walletModule.changeRoute(WidgetRoutes.INSUFFICIENT_FUNDS);
                }
            }
            this.paymentRequestCompleted.dispatch();
        })
    }

    resolvePendingRequests() {
        const pendingRequests = this.pendingRequests;
        this.pendingRequests = null;
        for (const args of pendingRequests) {
            this.requestPayment(...(args as [any, any, any]));
        }
    }

    requestPayment(request: PaymentRequest, callback = NOOP_FUNCTION, errorCallback = NOOP_FUNCTION) {
        // TODO @pay @branch not more than one pending request. If we haven't send the other one just drop it.
        if (this.pendingRequests != null) {
            this.pendingRequests.push(arguments);
            return;
        }

        this.lastPaymentRequestData = request;
        this.paymentRequests.set(request.offerId, {request});
        const paymentCallbacksForOffer = this.paymentCallbacks.get(request.offerId) || {
            onSuccess: [],
            onError: [],
        };
        paymentCallbacksForOffer.onSuccess.push(callback);
        paymentCallbacksForOffer.onError.push(errorCallback);
        this.paymentCallbacks.set(request.offerId, paymentCallbacksForOffer);
        this.paymentRequestReceived.dispatch();
        walletModule.widget.sendMessage(IFrameMessages.PAYMENT_REQUEST, request);
    }
}

export const purchaseModule = new PurchaseModule();
